var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.setupCompleted)?_c('div',{staticClass:"TableWrapper"},[(! _vm.noAccessibleConfigs)?_c('Table',{ref:"table",attrs:{"loading":_vm.loading},on:{"refresh":_vm.handleRefresh}},[_vm._t("default")],2):_c('div',[_vm._v(" U heeft onvoldoende rechten om deze lijstweergave te bekijken. ")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }